import ErrorFeedbackScreen from '../../components/shared/ErrorFeedbackScreen/ErrorFeedbackScreen';
import ErrorRoundImage from '../../assets/images/error-round.webp';
import { CloseWebviewEvent } from '../../sdk/close.webview.event';
import useTranslation from '../../localization/i18n.context';
import { useEffect } from 'preact/hooks';
import { DeeplinkEvent } from '../../sdk/deeplink.event';
import LuckyDeeplink from '../../constants/lucky.deeplink';
import { TrackingEvent } from '../../sdk/tracking.event';

export default function ReportCardErrorPage() {
  const { t } = useTranslation();

  const closeWebview = () => {
    CloseWebviewEvent.finishWithError();
  };

  const chatWithAgent = () => {
    // TODO : it is required to change in the future when we implement another client.
    DeeplinkEvent.open(LuckyDeeplink.FAQS);
  };
  useEffect(() => {
    TrackingEvent.trigger(
      TrackingEvent.Events.REPORT_CARD_REPRINT_ERROR_SHOW,
      TrackingEvent.Sources.CAAS,
    );
  }, []);
  return (
    <ErrorFeedbackScreen
      onCloseClick={closeWebview}
      image={ErrorRoundImage}
      title={t('Ooops!')}
      text={t(
        "Something went wrong and we couldn't request a new card. Please try again, or contact customer support.",
      )}
      ctaAction={chatWithAgent}
      ctaText={t('Contact customer support')}
    />
  );
}
